
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"61","height":"36","viewBox":"0 0 61 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.211 5.485h2.742v23.311H5.211V5.486zM19.197 5.485h-2.742v17.826h2.742V5.485zM23.996 5.485h4.114v17.826h-4.114V5.485zM11.655 5.485h-1.37v17.826h1.37V5.485zM20.568 5.485h1.371v17.826h-1.37V5.485zM15.083 5.485h-1.37v17.826h1.37V5.485zM35.652 5.485h2.742v17.826h-2.742V5.485zM47.307 5.485h-4.114v17.826h4.114V5.485zM29.481 5.485h1.371v17.826h-1.371V5.485zM41.136 5.485h-1.37v17.826h1.37V5.485zM49.364 5.485h1.371v17.826h-1.37V5.485zM34.28 5.485h-1.37v17.826h1.37V5.485zM52.518 5.485h2.742v23.311h-2.742V5.486zM17.825 26.053h-2.742v2.742h2.742v-2.742zM20.568 28.795v-2.742h2.742v2.742h-2.742zM28.795 26.053h-2.742v2.742h2.742v-2.742zM31.538 28.795v-2.742h2.742v2.742h-2.742zM39.765 26.053h-2.742v2.742h2.742v-2.742zM42.508 26.053h2.742v2.742h-2.742v-2.742zM47.993 26.053v2.742h2.742v-2.742h-2.742zM9.6 26.053h2.741v2.742H9.6v-2.742z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.17 35.652h47.993a6.145 6.145 0 006.17-6.17V6.17A6.145 6.145 0 0054.163 0H6.17A6.145 6.145 0 000 6.17v23.311a6.145 6.145 0 006.17 6.171zM4.854 2.995a3.4 3.4 0 011.316-.253h47.993a3.4 3.4 0 013.428 3.428v23.311a3.4 3.4 0 01-3.428 3.428H6.17a3.398 3.398 0 01-3.428-3.428V6.17a3.4 3.4 0 012.112-3.175z"}})])
          )
        }
      }
    